export const GET_WEBSITE_APPEARANCE = "GET_WEBSITE_APPEARANCE";
export const GET_WEBSITE_APPEARANCE_SUCCESS = "GET_WEBSITE_APPEARANCE_SUCCESS";
export const GET_WEBSITE_APPEARANCE_FAILURE = "GET_WEBSITE_APPEARANCE_FAILURE";
